import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { CloseOutlined } from "@mui/icons-material";
import {
  IconButton,
  Box,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/material";

import FileUpload from "components/FileUpload/FileUpload";
import { bulkUploadFiles } from "actions/documentsActions";
import { selectIsUploading } from "selectors/documentsSelectors";
import { decodeToken } from "core/utils/appUtils";

export const FileManagerUploadHeader = ({ title, handleClose }) => {
  return (
    <div className={"d-flex justify-content-between"}>
      <Typography className="h3 m-3">{`Upload documents for ${title}`}</Typography>
      <IconButton onClick={handleClose}>
        <CloseOutlined style={{ fontSize: "2rem" }} />
      </IconButton>
    </div>
  );
};
export const FileManagerUploadContent = ({
  filesBelongsTo,
  selectedData,
  onUploadSuccess,
}) => {
  const entity = filesBelongsTo.toLowerCase();
  //Files Upload and Retrival
  const dispatch = useDispatch();
  const isUploading = useSelector(selectIsUploading);

  const [filesState, setFilesState] = React.useState([]);
  const [fileLabelsState, setFileLabelsState] = React.useState({});
  const [documentTypeState, setDocumentTypeState] = React.useState("");

  const handleUploadFiles = (onUploadSuccessCallback) => {
    dispatch(
      bulkUploadFiles(
        filesState,
        fileLabelsState,
        documentTypeState,
        entity === "company" ? decodeToken()?.CompanyId : selectedData[entity],
        filesBelongsTo,
        () => {
          onUploadSuccess();
          onUploadSuccessCallback();
        }
      )
    );
  };

  return (
    <div className="file-manager-container">
      <div
        className="file-manager-upload-documents"
        data-testid="fm-upload-documents"
      >
        <FileUpload
          setFilesState={setFilesState}
          setFileLabelsState={setFileLabelsState}
          setDocumentTypeState={setDocumentTypeState}
          onUploadButtonClick={handleUploadFiles}
          showUploadCancelButtons
          defaultDocumentType={filesBelongsTo}
        />
        {isUploading && (
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <Box sx={{ width: "100%" }}>
              <Typography variant="body1">Uploading Documents</Typography>
              <LinearProgress size="3rem" />
            </Box>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default FileManagerUploadContent;
